<template>
  <div
    v-loading.fullscreen.lock="loadingSave"
    :element-loading-text="'Processando...'+(requestParam.uploadProgress != null ? '\n'+requestParam.uploadProgress+'%' : '')"
  >
    <el-tabs v-model="tagConfig">
      <el-tab-pane label="Config" name="tab-cadastro">
        <span slot="label">
          <i class="fa fa-pencil-square-o"></i> Informações do Orçamento
        </span>

        <ed-form :data="formData" :config="config" :response="response" :itens="formItems">
          <div slot="form-footer"></div>
        </ed-form>
      </el-tab-pane>

      <el-tab-pane label="Config" name="tab-risco" v-if="formData.id>0">
        <span slot="label">
          <i class="fa fa-pencil-square-o"></i> Informações das Medições
        </span>

        <el-tabs type="border-card" v-model="tagConfigResumo">
          <el-tab-pane label="Config" name="tab-res-med">
            <span slot="label">
              <i class="fa fa-file-text-o"></i> Medições
            </span>
            <Medicao :orcamento="orcamento" />
          </el-tab-pane>

          <el-tab-pane label="Config" name="tab-res-cus">
            <span slot="label">
              <i class="fa fa-usd"></i> Custos
            </span>
            <Servico :orcamento="orcamento" />
          </el-tab-pane>

        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="Config" name="tab-email" v-if="formData.id>0">
        <span slot="label"><i class="fa fa-paper-plane"></i> Propostas Enviadas</span>
        <LogEmail point_type="ltcat_orcamento" :point_id="orcamento.id"/>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import EdModal from "common/modal";
import FormItems from "./_form/orcamento-editar";
import Medicao from "./medicao";
import Servico from "./servico";
import LogEmail from 'appsWeb/log/email/index'

export default {
  name: "exame-editar",
  components: { EdForm, EdModal, Medicao, Servico,LogEmail },
  mixins: [Rest],
  props: {
    parent: {
      type: [Object, Window],
      default: null
    },
    orcamento: {
      type: Object,
      default: null
    },
    showForm: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "orcamento.id"() {
      if (this.orcamento && this.orcamento.id != 0) {
        this.getOrcamento();
      }
    },
    showForm() {
      alert("asdf");
      this.showFormEdit = !this.showFormEdit;
      this.init();

      if (this.orcamento && this.orcamento.id != 0) {
        this.getOrcamento();
      }
    }
  },
  data() {
    return {
      config: {
        tipo: [234, 229],
        click: {
          save: this.salvar
        },
        loading: {
          save: false,
          content: false
        },
        list: {},
        disabled: {
          codigo: true,
        }
      },
      formData: {
        id: 0,
        id_tipo_status: null,
        descricao: null,
        updated_at: null,
        usuario: null
      },
      response: {},
      formItems: [],
      loadingSave: false,
      showFormEdit: false,
      tagConfig: "tab-cadastro",
      tagConfigResumo: "tab-res-med"
    };
  },

  mounted() {
    this.formItems = FormItems;
    this.getOrcamento();

    this.$events.on('orcamentoProposta', eventData => {
      this.getOrcamento();
    });
  },

  methods: {
    init() {
      this.formData = {
        id: 0,
        codigo: null,
        id_tipo_status: null,
        descricao: null,
        updated_at: null,
        usuario: null
      };
    },

    getOrcamento() {
      if (!this.orcamento || this.orcamento.id == 0) return;

      this.config.loading.content = true;
      this.tagConfig = "tab-cadastro";
      this.formData = {};

      this.get(
        "ltcat/orcamento/" +
          this.$store.state.ltcat.data.id +
          "/" +
          this.orcamento.id
      ).then(result => {
        result = result[0];

        this.config.loading.content = false;

        if (result.status == 200) {
          this.formataData(result);
        }
      });
    },

    formataData(result) {
      this.formData = {
        id: result.data.id,
        id_tipo_status: result.data.tipo_status.id,
        codigo: result.data.codigo,
        descricao: result.data.descricao,
        usuario: result.data.usuario,
        updated_at: result.data.updated_at
      };
    },

    salvar() {
      this.response = {};
      this.loadingSave = true;

      this.post(
        "/ltcat/orcamento/" + this.$store.state.ltcat.data.id + "/editar",
        this.formData
      ).then(result => {
        result = result[0];

        this.loadingSave = false;
        this.response = result;

        if (result.status == 200) {
          this.edMsg("Registro salvo com sucesso!");
          this.formataData(result);
          this.showFormEdit = !this.showFormEdit;

          if (this.parent.getLtcatOrcamento) this.parent.getLtcatOrcamento();
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// editar.vue?17b85522